import { TRESPONSE_WEEKLY_OPL_CAPACITIES } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import _ from 'lodash';
import { TTableCellTree, TTableOptions } from '../../table.type';

function _getWeeklyCells(
  item: TRESPONSE_WEEKLY_OPL_CAPACITIES['otlCapacities'][number],
  fieldInfo: TRESPONSE_WEEKLY_OPL_CAPACITIES['fieldInfo'],
) {
  const dynamicFields: TTableCellTree[] = _.map(fieldInfo, (val) => {
    switch (val.key) {
      case 'load':
        return {
          type: 'TEXT_CELL',
          text: item.fields[val.key][0] ? '' : '--',
          tag: item.fields[val.key][0]
            ? {
                tagContent: 'Overloaded',
                tagBgColor: 'red',
              }
            : undefined,
        };
      case 'user_otl_id':
        return {
          type: 'TEXT_CELL',
          text: item.fields[val.key][0],
          hrefActionCB: 'ORDER_DETAILS_REDIRECT',
        };
      default:
        return {
          type: 'TEXT_LIST_CELL',
          text: item.fields[val.key],
        };
    }
  });

  const fixedCells: TTableCellTree[] = [
    {
      type: 'ACTION_CELL',
      actionType: 'CUSTOM_ACTION',
      actionId: 'SPLIT_ORDER',
      customIconPath: 'assets/common/split-arrows.svg',
    },
    {
      type: 'ACTION_CELL',
      actionType: 'CUSTOM_ACTION',
      actionId: 'OTL_ORDER',
      customIconPath: 'assets/common/arrow-right-black.svg',
    },
  ];

  return dynamicFields.concat(fixedCells);
}

function _getWeeklyHeaderConfig(
  fieldInfo: TRESPONSE_WEEKLY_OPL_CAPACITIES['fieldInfo'],
  res?: TRESPONSE_WEEKLY_OPL_CAPACITIES,
) {
  const dynamicHeaders: TTableOptions['headerConfig'] = fieldInfo.map((x) => {
    const defaultInfo: TTableOptions['headerConfig'][number] = {
      type: 'TEXT_CELL',
      text: x.display_name,
    };

    switch (x.key) {
      case 'user_otl_id':
        return {
          ...defaultInfo,
          widthInPx: 100,
        };
      case 'allocated_sah':
        return {
          ...defaultInfo,
          subtitle: {
            text: res ? `${res.allocatedCapacity}/${res.installedCapacity}` : '',
            align: 'BLOCK',
            fontSize: {
              value: 14,
              unit: 'px',
            },
          },
        };
      case 'capacity_utilized': {
        const subTxt = res ? ((res.allocatedCapacity / res.installedCapacity) * 100).toString() : '';
        return {
          ...defaultInfo,
          subtitle: {
            text: res ? `${parseFloat(subTxt).toFixed(2)}%` : '',
            align: 'BLOCK',
            fontSizeInPx: 14,
          },
        };
      }
      default:
        return defaultInfo;
    }
  });

  const actionCell: TTableOptions['headerConfig'][number] = {
    type: 'TEXT_CELL',
    text: '',
    widthInPx: 32,
  };
  return dynamicHeaders.concat([actionCell, actionCell]);
}

export const WEEKLY_OPL_INFO_TABLE_MODEL = {
  createModel: (
    fieldInfo: TRESPONSE_WEEKLY_OPL_CAPACITIES['fieldInfo'],
    otlCapacities: TRESPONSE_WEEKLY_OPL_CAPACITIES['otlCapacities'],
    res?: TRESPONSE_WEEKLY_OPL_CAPACITIES,
  ) => {
    return ModifiersZTableModel.createTableModel(
      otlCapacities,
      { headerConfig: _getWeeklyHeaderConfig(fieldInfo, res) },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: _getWeeklyCells(item, fieldInfo),
        };
      },
    );
  },
};
